const NAME = 'ORG_COMMENT_ADD';

export const UPDATE_NEW_COMMENT = `${NAME}/UPDATE_NEW_COMMENT`;

export const REQUEST_ADD_COMMENT = `${NAME}/REQUEST_ADD_COMMENT`;
export const ADD_COMMENT_COMPLETED = `${NAME}/ADD_COMMENT_COMPLETED`;
export const ADD_COMMENT_FAILED = `${NAME}/ADD_COMMENT_FAILED`;
